export default __webpack_public_path__ + "static/media/xtinge-logo-named-orange-en.70c09d39.png";